// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useCountriesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getCountries = () => {
    return request("GET", `${API_STAGES_URL}/v1/countries`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getCountries,
    },
  ]
}

export default useCountriesApi
